export const isNumber = (value) => {
    if (value === undefined || value === null) {
        return false;
    }
    if (typeof value !== 'string' && typeof value !== 'number') {
        return false;
    }
    if (value === '') {
        return false;
    }
    return !Number.isNaN(Number(value));
};
export const toFixed = (value, precision, options) => {
    if (Number.isNaN(Number(value))) {
        throw Error('toFixed value must be a number or a string that can be converted to a number. ' +
            `Failed to convert ${value}`);
    }
    value = Number(value);
    if (precision < 0)
        throw Error('toFixed precision cannot be less than 0');
    const power = Math.pow(10, precision);
    const absValue = Math.abs(Math.round(value * power));
    let result = (value < 0 ? '-' : '') + String(Math.floor(absValue / power));
    if (precision > 0) {
        const fraction = String(absValue % power);
        const padding = new Array(Math.max(precision - fraction.length, 0) + 1).join('0');
        result += '.' + padding + fraction;
    }
    if (options === null || options === void 0 ? void 0 : options.trimTrailingZeros) {
        return parseFloat(result).toString();
    }
    return parseFloat(result).toFixed(precision);
};
